import { useEffect } from "react";
import { X } from "lucide-react";

export default function Drawer({ open, onClose, title, eyebrow, children, width = 720, testid }) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex" data-testid={testid}>
      <div className="flex-1 bg-black/40" onClick={onClose} />
      <div
        className="bg-white border-l border-gray-200 shadow-2xl flex flex-col w-full sm:max-w-[95vw]"
        style={{ maxWidth: width }}
      >
        <div className="px-4 sm:px-6 py-4 border-b border-gray-200 flex items-start justify-between sticky top-0 bg-white z-10">
          <div className="min-w-0 flex-1 pr-3">
            {eyebrow && <div className="label-eyebrow">{eyebrow}</div>}
            <h2 className="font-display text-xl sm:text-2xl font-bold tracking-tight mt-1 break-words">{title}</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-black p-1 flex-shrink-0" data-testid="drawer-close">
            <X size={20} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
